/**
 * Gallery like styled lightbox component for presenting various types of media
 * @requires https://github.com/biati-digital/glightbox
 */

export default (() => {
  const lightboxEl = document.querySelector('[data-glightbox]')

  if (lightboxEl === null) return

  const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
    <div class="gloader visible"></div>
    <div class="goverlay"></div>
    <div class="gcontainer">
      <div id="glightbox-slider" class="gslider"></div>
      <button class="gnext gbtn btn btn-icon btn-outline-secondary animate-slide-end bg-body rounded-circle" style="width: 48px; height: 48px" tabindex="0" aria-label="Next">
        <svg class="animate-target" xmlns="http://www.w3.org/2000/svg" style="width: 24px" viewBox="0 0 24 24"><path d="M9.4 5.6c.3-.3.9-.3 1.2 0l6 6c.3.3.3.9 0 1.2l-6 6c-.3.3-.9.3-1.2 0-.4-.3-.4-.8 0-1.2l5.4-5.4-5.4-5.3C9 6.5 9 6 9.4 5.6"/></svg>
      </button>
      <button class="gprev gbtn btn btn-icon btn-outline-secondary animate-slide-start bg-body rounded-circle" style="width: 48px; height: 48px" tabindex="1" aria-label="Previous">
        <svg class="animate-target" xmlns="http://www.w3.org/2000/svg" style="width: 24px" viewBox="0 0 24 24"><path d="M14.6 5.6c.4.4.4.9 0 1.3l-5.4 5.4 5.4 5.4c.3.3.3.9 0 1.2s-.9.3-1.2 0l-6-6c-.4-.4-.4-.9 0-1.3l6-6c.3-.3.9-.3 1.2 0"/></svg>
      </button>
      <button class="gclose gbtn btn btn-icon btn-outline-secondary bg-body rounded-circle" tabindex="2" aria-label="Close" style="width: 48px; height: 48px">
        <svg xmlns="http://www.w3.org/2000/svg" style="width: 24px" viewBox="0 0 24 24"><path d="M18.6 17.4c.3.3.3.9 0 1.2s-.9.3-1.2 0L12 13.2l-5.4 5.4c-.3.3-.9.3-1.2 0s-.3-.9 0-1.2l5.4-5.4-5.4-5.4c-.4-.3-.4-.9 0-1.2.3-.4.9-.4 1.2 0l5.4 5.4 5.4-5.4c.3-.3.9-.3 1.2 0s.3.9 0 1.2L13.2 12z"/></svg>
      </button>
    </div>
  </div>`

  /* eslint-disable no-unused-vars, no-undef */
  const lightbox = GLightbox({
    selector: '[data-glightbox]',
    lightboxHTML: customLightboxHTML,
    openEffect: 'fade',
    closeEffect: 'fade',
    closeOnOutsideClick: false,
    videosWidth: '1200px',
  })
  /* eslint-enable no-unused-vars, no-undef */
})()
